import { GuestEmailAvailability, GuestEmailAvailabilityRequest } from './data-contracts';
import { ContentType, HttpClient, RequestParams, TraceDataType } from './http-client';

import { loggerCan } from '@/data/utils/loggerUtil';
import { logger } from '@/logging/logger';

export class GuestValidateEmail<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
	}

	/**
	 * @description Validate email availabitliy
	 *
	 * @tags Guest Validate Email
	 * @name GuestValidateEmail
	 * @summary Get availability of emails
	 * @request POST:/store/{storeId}/cart/@self/guest_checkout?responseFormat=json
	 * @response `200` `GuestEmailAvailability` The requested completed succesfully
	 */
	guestValidateEmail = (
		storeId: string,
		data: GuestEmailAvailabilityRequest,
		query?: {
			/**
			 * Language identifier. If not specified, the "locale" parameter is used. If "locale" is not specified, then the store default language is used.
			 * @example "-1, -2, -3, -4, -5"
			 */
			langId?: string;
		},
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (
			loggerCan('trace') &&
			(!this.http.traceDetails || this.http.traceDetails['guestValidateEmail'])
		) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/store/${storeId}/cart/@self/guest_checkout?responseFormat=json`,
				params: _params,
				query: query,
				body: data,
				methodName: 'guestValidateEmail',
			};
			logger.trace(traceData);
		}
		return this.http.request<GuestEmailAvailability, any>({
			path: `/store/${storeId}/cart/@self/guest_checkout?responseFormat=json`,
			method: 'POST',
			query: query,
			body: data,
			type: params.type ?? ContentType.Json,
			format: params.format ?? 'json',
			storeId,
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
}
